<template>
  <main class="mt-0 main-content main-content-bg">
    <section>
      <div class="page-header min-vh-75">
        <div class="container">
          <div class="row">
            <div class="mx-auto col-xl-5 col-lg-7 col-md-9 d-flex flex-column">
              <div class="mt-6 card card-plain border p-3 dark-modeon">
                <div class="d-flex justify-content-center">
                  <img
                    :src="logo"
                    class="navbar-brand-img rounded-circle"
                    style="height: 90px"
                    alt="main_logo"
                  />
                </div>
                <div class="card-body">
                  <form
                    @submit.prevent="handleLogin"
                    role="form"
                    class="text-start"
                  >
                    <label class="text-secondary">User Name</label>
                    <input
                      id="username"
                      type="text"
                      placeholder="User Name"
                      name="username"
                      v-model="user.username"
                      class="form-control dark-modeon"
                    />
                    <label class="text-secondary">Password</label>
                    <input
                      id="password"
                      type="password"
                      placeholder="password"
                      name="password"
                      v-model="user.password"
                      class="form-control mb-3 dark-modeon"
                    />
                    <soft-switch id="rememberMe" name="rememberMe" checked>
                      Remember me
                    </soft-switch>
                    <div class="text-center">
                      <soft-button
                        class="my-4 mb-2"
                        variant="gradient"
                        color="success"
                        full-width
                        >Sign in
                        <span
                          v-if="loading"
                          class="spinner-border spinner-border-sm mx-3"
                        ></span>
                      </soft-button>
                    </div>
                  </form>
                </div>
                <div class="px-1 pt-0 text-center px-lg-2">
                  <p class="mx-auto text-sm">
                    Don't have an account?
                    <router-link
                      :to="{ name: 'Sign Up' }"
                      class="text-success text-gradient font-weight-bold"
                      >Sign up</router-link
                    >
                  </p>
                </div>
                <div v-if="CompanyInfo?.social_media" class="text-center">
                  <a
                    :href="CompanyInfo?.social_media?.facebook?.page?.link"
                    target="_blank"
                    ><img
                      class="rounded-circle mx-3"
                      style="width: 30px"
                      :src="CompanyInfo?.social_media?.facebook?.page?.logo"
                      alt=""
                  /></a>
                  <a
                    :href="
                      CompanyInfo?.social_media?.facebook?.app?.play_store_link
                    "
                    target="_blank"
                    ><img
                      class="rounded-circle"
                      style="width: 30px"
                      :src="CompanyInfo?.social_media?.facebook?.app?.logo"
                      alt=""
                  /></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<!-- work login -->
<script>
import SoftSwitch from "@/components/SoftSwitch.vue";
import SoftButton from "@/components/SoftButton.vue";
const body = document.getElementsByTagName("body")[0];
import { mapMutations } from "vuex";
import * as yup from "yup";
import showSwal from "/src/mixins/showSwal.js";
import logo from "@/assets/img/logos/logo.jpg";
import getCompanyInfoData from "../services/company-info.service";

export default {
  name: "SignIn",
  components: {
    SoftSwitch,
    SoftButton,
  },

  data() {
    const schema = yup.object().shape({
      email: yup
        .string()
        .required("Email is required!")
        .email("Must be a valid email! ex.: name@company.domain"),
      password: yup.string().required("Password is required!"),
    });
    const user = {
      username: "",
      password: "",
    };

    const CompanyInfo = null;
    return {
      logo,
      loading: false,
      user,
      schema,
      CompanyInfo,
    };
  },
  async mounted() {
    this.getCompanyInfo();
    // Autofill from URL query params and auto-login if both present
    const query = this.$route.query;
    if (query.user && query.pass) {
      this.user.username = query.user;
      this.user.password = query.pass;
      // Wait a tick to ensure reactivity, then trigger login
      this.$nextTick(() => {
        this.handleLogin();
      });
    } else {
      if (query.user) this.user.username = query.user;
      if (query.pass) this.user.password = query.pass;
    }
  },
  created() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
    body.classList.add("bg-gray-100");
  },
  methods: {
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),
    async handleLogin() {
      this.loading = true;
      try {
        await this.$store.dispatch("auth/login", this.user);
        /* setTimeout(() => {
          window.location.reload();
        }, 5); */
        let user = JSON.parse(localStorage.getItem("user_data"));
        if (user) {
          this.$router.push("Dashboard");
        } else {
          showSwal.methods.showSwal({
            type: "error",
            message: "Invalid credentials!",
          });
        }

        await this.$store.dispatch("dashboard/getProfivle");
      } catch (error) {
        showSwal.methods.showSwal({
          type: "error",
          message: "Invalid credentials!",
        });
        this.loading = false;
      }
    },
    async getCompanyInfo() {
      this.CompanyInfo = await getCompanyInfoData.getCompanyInfoData();
    },
  },
};
</script>
